import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: true },
    dismissDelay: { type: Number, default: 30000 } // 30 seconds in milliseconds
  };

  connect() {
    if (this.autoDismissValue) {
      this.timeoutId = setTimeout(() => {
        this.dismiss();
      }, this.dismissDelayValue);
    }
  }

  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  dismiss() {
    this.element.classList.add("dismissible--closing");

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }

  close(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dismiss();
  }
}
